module.exports = __webpack_public_path__ + "static/media/Adam.4f2fef2b.png";